import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import NotificationImportantOutlinedIcon from '@mui/icons-material/NotificationImportantOutlined';
// import UserInfoNoAccess from 'components/NoAccessAcademy/UserInfoNoAccess/UserInfoNoAccess';
// import CodeSection from 'components/NoAccessAcademy/CodeSection/CodeSection';
import { academyDataActions } from '../../store/academy-slice';

import classes from './DisabledAcademy.module.css';

const DisabledAcademy = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: true
      })
    );
  }, []);

  return (
    <div className={classes.disabledAcademyContainer}>
      <aside className={classes.textContainer}>
        <p className={classes.text}>
          <NotificationImportantOutlinedIcon
            className={classes.icon}
          />{' '}
          <span className={classes.info}>
            La Academia está actualmente fuera de servicio
          </span>
        </p>
      </aside>
    </div>
  );
};

export default DisabledAcademy;
